var _polygon, _polygon2, _polygon3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowsLiveSecondInnings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrows-live arrows-live--second-innings",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "arrows-live__arrow arrows-live__arrow--1",
    points: "8,10.8 0,2.8 2.8,0 8,5.3 13.2,0 16,2.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "arrows-live__arrow arrows-live__arrow--2",
    points: "8,21.4 0,13.4 2.8,10.6 8,15.9 13.2,10.6 16,13.4 8,21.4 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "arrows-live__arrow arrows-live__arrow--3",
    points: "8,32 0,24 2.8,21.2 8,26.5 13.2,21.2 16,24 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsLiveSecondInnings);
export default __webpack_public_path__ + "static/media/arrows-live-second-innings.fb327dce.svg";
export { ForwardRef as ReactComponent };